export const update_currency_conversion = `subscription update_currency_conversion{
    update_currency_conversion{
        transaction_code
        status
        account
        from_currency{
            currency
            name
            decimal
        }
        to_currency{
            currency
            name
            decimal
        }
        from_amount
        to_amount
        exchange_rate
        order_date
    }
}`;
